import { useMemo } from 'react';
import { normalize } from 'viem/ens';
import { useEnsAddress, useEnsAvatar, useEnsText } from 'wagmi';

interface EnsProfileProps {
  ensName: string;
  key?: string;
  chainId?: number;
}

interface EnsProfileResult {
  ensAddress: `0x${string}` | null | undefined;
  ensAvatar: string | null | undefined;
  ensTextData: string | null | undefined;
  isValid: boolean;
}

export const useEnsProfile = ({ ensName, key = 'text', chainId = 1 }: EnsProfileProps): EnsProfileResult => {
  const normalizedName = useMemo(() => {
    try {
      return normalize(ensName);
    } catch {
      return '';
    }
  }, [ensName]);

  const { data: ensAddress } = useEnsAddress({ name: normalizedName, chainId });
  const { data: ensAvatar } = useEnsAvatar({ name: normalizedName, chainId });
  const { data: ensTextData } = useEnsText({ name: normalizedName, chainId, key });

  return {
    ensAddress,
    ensAvatar,
    ensTextData,
    isValid: Boolean(normalizedName),
  };
};
